import React from "react";
import {
  Box,
  Chip,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { GlobalSidePanel } from "components/DesignSystem/GlobalSidePanel";
import { designWeights } from "services/constants/designTokens";
import { EmptyState } from "components/CustomComponents/EmptyState";

// Read-only aggregation (P1): every row just links back to the module that
// owns the item - Leave rows go to My Zone > Apply > Leave, the same screen
// Home's "My Pending Requests" card links to. There is no inline
// resolve/complete action here; that arrives per item type in P2.
export const ActionCentreDrawer = ({ open, onClose, groups }) => {
  const history = useHistory();

  const goToItem = (path) => {
    onClose();
    history.push(path);
  };

  return (
    <GlobalSidePanel open={open} onClose={onClose} title="Action Centre">
      <Box sx={{ p: 3 }}>
        {groups.length === 0 ? (
          <EmptyState subtitle="Nothing needs your attention." />
        ) : (
          groups.map((group) => (
            <Box key={group.type} sx={{ mb: 3 }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 1, pl: 2, pr: 2.5 }}
              >
                <Typography variant="subtitle1" fontWeight={designWeights.heading}>
                  {group.itemLabel}s
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    cursor: "pointer",
                    color: "primary.main",
                    fontWeight: designWeights.semibold,
                  }}
                  onClick={() => goToItem(group.viewAllPath)}
                >
                  View all
                </Typography>
              </Stack>
              <List disablePadding>
                {group.items.map((item) => (
                  <ListItemButton
                    key={item.id}
                    onClick={() => goToItem(group.viewAllPath)}
                    sx={{
                      border: "1px solid #eee",
                      borderRadius: 2,
                      mb: 1,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <ListItemText
                      primary={item.title}
                      secondary={item.subtitle}
                    />
                    <Chip label={item.status} size="small" color="warning" />
                  </ListItemButton>
                ))}
              </List>
            </Box>
          ))
        )}
      </Box>
    </GlobalSidePanel>
  );
};
